module.exports = __webpack_public_path__ + "static/media/CRM.db77d028.svg";